import { useEffect, useState } from "react";
import { getPipelineStatus } from "../../lib/api";
import { StatusBadge } from "../shared/StatusBadge";

export const PipelineStatusStrip = () => {
  const [stages, setStages] = useState([]);

  useEffect(() => {
    getPipelineStatus()
      .then((data) => setStages(data.stages || []))
      .catch(() => setStages([]));
  }, []);

  if (!stages.length) return null;

  return (
    <div data-testid="pipeline-status-strip" className="rounded-lg border border-white/10 bg-eb-surface p-4">
      <h3 className="mb-3 font-heading text-sm uppercase tracking-wide text-zinc-400">System Pipeline Status</h3>
      <div className="flex flex-wrap gap-2">
        {stages.map((stage) => (
          <div key={stage.key} className="flex items-center gap-2 rounded-md border border-white/10 px-2.5 py-1.5">
            <span className="text-xs text-zinc-400">{stage.label}</span>
            <StatusBadge status={stage.status} testId={`pipeline-status-${stage.key}`} />
          </div>
        ))}
      </div>
    </div>
  );
};
